export default [
  {
    path: '/portal-propostas/landing',
    name: 'portalproposta',
    component: () => import('@/app-modulo/comercial/portal-proposta/LandingPage.vue'),
    meta: {
      requiredAuth: false,
      resource: 'portalpropostaexterno',
      action: 'read',
      layout: 'full',
    },
  },
  {
    path: '/portal-propostas/proposta-apresentacao',
    name: 'portalproposta-apresentacao',
    component: () => import('@/app-modulo/comercial/portal-proposta/FluxoPropostaApresentacao.vue'),
    meta: {
      requiredAuth: false,
      resource: 'portalpropostaexterno',
      action: 'read',
      layout: 'full',
    },
  },
  {
    path: '/portal-propostas/checklist-apresentacao',
    name: 'portalproposta-checklist-apresentacao',
    component: () => import('./FluxoChecklistApresentacao.vue'),
    meta: {
      requiredAuth: false,
      resource: 'portalpropostaexterno',
      action: 'read',
      layout: 'full',
    },
  },
  {
    path: '/portal-propostas',
    name: 'portalproposta-externo',
    component: () => import('@/app-modulo/comercial/portal-proposta/PortalProposta.vue'),
    meta: {
      requiredAuth: false,
      resource: 'portalpropostaexterno',
      action: 'read',
      hideNavMenu: true,
    },
  },
  {
    path: '/portal-propostas/:propostaId/documentos',
    name: 'portalproposta-documentos',
    component: () => import('@/app-modulo/comercial/portal-proposta/DocumentosProposta.vue'),
    meta: {
      requiredAuth: false,
      resource: 'portalpropostaexterno',
      action: 'read',
      layout: 'full',
    },
  },
  {
    path: '/assinatura/:documentoId',
    name: 'portalproposta-assinador',
    component: () => import('@/app-modulo/comercial/assinador-documentos/AssinadorDocumento.vue'),
    meta: {
      requiredAuth: false,
      resource: 'portalpropostaexterno',
      action: 'read',
      layout: 'full',
    },
  },
  {
    path: '/assinatura/consulta/:publicKey',
    name: 'portalproposta-consulta',
    component: () => import('@/app-modulo/comercial/assinador-documentos/ConsultaPublicaDocumentoAssinatura.vue'),
    meta: {
      requiredAuth: false,
      resource: 'portalpropostaexterno',
      action: 'read',
      layout: 'full',
    },
  },
]
